import { Arg, Metadata } from '../../../../utils/spds/metadata';
import { or } from 'ember-truth-helpers';
import FlexRow from '../../layout/flex/row.gjs';
import Super from '../base.gjs';
import styles from './no-results.module.scss';

const METADATA = Metadata.define({
  description: 'Displays a no results found message within a menu.',
  meta: {
    text: Arg.string({
      description:
        'The text to display when there are no results. Defaults to "No matching results".',
    }),
  },
  name: 'Menu No Results',
});

export default class SpdsCoreMenuNoResults extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  baseClass = 'spds-menu-no-results';
  styles = styles;

  <template>
    <FlexRow
      @content={{or @text "No matching results"}}
      class={{this.classes}}
      data-test-spds-menu-no-results
      {{this.validateArguments}}
    />
  </template>
}

export const SPDS_CORE_MENU_NO_RESULTS_METADATA = SpdsCoreMenuNoResults.metadata;
